import React from "react"
import '../styles/home.css'
import EmailIcon from '../assets/email_icon.png'
import GithubIcon from '../assets/github_icon.png'
import GoogleScholarIcon from '../assets/google_scholar_icon.png'
import ProfilePicture from '../assets/profile_picture.JPG'

function HomeIntroImages() {
    return (
        <div className="home-intro-images">
            <img
                src={ProfilePicture}
                className="home-intro-images-profile-picture"
                alt="headshot"
            />

            <div className="home-intro-images-icons">
                <a href="mailto:rjsandoval@berkeley.edu">
                    <img
                        src={EmailIcon}
                        alt="email"
                        className="email-icon"
                    />
                </a>
                <a href="https://github.com/RicardoJSandoval">
                    <img 
                        src={GithubIcon}
                        alt="Github"
                        className="github-icon"
                    />
                </a>
                <a href="https://scholar.google.bg/citations?user=2D1DoH8AAAAJ&hl=en">
                    <img 
                        src={GoogleScholarIcon}
                        alt="Google Scholar"
                        className="google-scholar-icon"
                    />
                </a>
            </div>
        </div>
    );
}

function HomeIntroWriting() {
    return (
        <div className="home-intro-writing">
        {/*<h1>
              Hi, I'm <span className="gradient-text">Ricardo</span>! 
            </h1>*/}
            <p className="intro">
                I'm a fourth-year PhD student in Computer Science at UC Berkeley, where I'm 
                fortunate to be advised 
                by <a className="links" href="https://www.avifeller.com/">Avi Feller</a> and <a className="links" href="https://people.eecs.berkeley.edu/~jordan/">Michael I. Jordan</a>.
                I also have the privilege to work closely with and be mentored 
                by <a className="links" href="https://ianws.com/">Ian Waudby-Smith</a>.
                I completed my undergrad in CS and Applied Math at Vanderbilt University, 
                where I was part of the <a className="links" href="https://www.vanderbilt.edu/ingram/">Ingram Scholars Program</a>.
            </p>

            <p className="intro">
                My interests span causal inference, anytime-valid sequential inference, algorithm design, and learning theory.
                
        {/*I completed my undergrad in CS and Applied Math at Vanderbilt University
                where I was part of the <a className="links" href="https://www.vanderbilt.edu/ingram/">Ingram Scholars Program</a>.
              During my undergrad I was lucky to work 
              with: <a className="links" href="https://www.redietabebe.com/">Rediet Abebe</a>
              , <a className="links" href="https://barbourww.github.io/">William Barbour</a>
              , <a className="links" href="https://glassmanlab.seas.harvard.edu/glassman.html">Elena Glassman</a>
              , <a className="links" href="https://www.cs.cornell.edu/home/kleinber/">Jon Kleinberg</a>
              , <a className="links" href="https://engineering.vanderbilt.edu/bio/himanshu-neema">Himanshu Neema</a>
              , <a className="links" href="https://engineering.vanderbilt.edu/bio/janos-sztipanovits">
                  Janos Sztipanovits
              </a>
              , and <a className="links" href="https://lab-work.github.io/about/">Dan Work</a>.*/}
            </p>
        </div>
    );
}

function HomeIntro() {
    return (
        <div className="home-intro">
            <HomeIntroImages />
            <HomeIntroWriting />
        </div>
    );
}


function TimelineItem(props) {
  return (
    <li>
      <div className="timeline-item">
        <div className="date">{props.date}:&nbsp;</div>
        <div className="news">{props.news}</div>
      </div>
    </li>
  );
}

function ProjectsHighlights() {
    return (
        <div className="home-projects-highlights">
            <div className="section-header">Projects Highlights</div>
        </div>
    );
}

function HomeNews() {
  return (
    <div className="home-news">
      <div className="section-header">News</div>
      <div className="timeline">
        <ul className="timeline-list">
          <TimelineItem
            date="May 13, 2022"
            news="I graduated from Vanderbilt University!"
          />
        </ul>
      </div>
    </div>
  );
}

/*<HomeNews />*/
export default function Home(){
  return (
    <div>
      <HomeIntro />
      {/*<ProjectsHighlights />*/}
    </div>
  );
}

